import React from 'react';
import ArcSelector from '../ArcSelector/ArcSelector';

const ArcFieldSelector = (props) => {

    const moveTop = (record) => {
        const newData = props.data.filter((r) => r.id === record.id);
        for (const line of props.data) {
            if (line.id !== record.id) {
                newData.push(line);
            }
        }
        props.changeHandler(props.config.Id, newData);   
    }

    const moveUp = (record) => {
        const position = props.data.findIndex((r) => r.id === record.id);
        const newData = [];

        if (position > 0) {
            const lineToMove = props.data.filter((r) => r.id === record.id)[0];
            let count = 0;
            for (const line of props.data) {
                if (position-1 === count) {
                    newData.push(lineToMove)
                }
                if (line.id !== record.id) {
                    newData.push(line);
                }
                count++;
            }
            props.changeHandler(props.config.Id, newData);   
        }

    }

    const moveDown = (record) => {
        const position = props.data.findIndex((r) => r.id === record.id);
        const newData = [];

        if (position < props.data.length - 1) {
            const lineToMove = props.data.filter((r) => r.id === record.id)[0];
            let count = 0;
            let found = false;
            for (const line of props.data) {
                if (position+2 === count) {
                    newData.push(lineToMove)
                    found = true
                }
                if (line.id !== record.id) {
                    newData.push(line);
                }
                count++;
            }
            if (! found) {
                newData.push(lineToMove);
            }
            props.changeHandler(props.config.Id, newData);   
        }
    }

    const moveBottom = (record) => {
        const newData = [];
        for (const line of props.data) {
            if (line.id !== record.id) {
                newData.push(line);
            }
        }
        const recordToMove = props.data.filter((r) => r.id === record.id)[0];
        newData.push(recordToMove);
        props.changeHandler(props.config.Id, newData);   
    }

    const menuClick = (record, menu) => {
        if (menu !== undefined) {
            switch(menu.key) {
                case "moveTop":
                    moveTop(record);
                    break;
                case "moveUp":
                    moveUp(record);
                     break;
                case "moveDown":
                    moveDown(record);
                    break;
                case "moveBottom":
                    moveBottom(record);
                    break;
                default:
              }
        }
    }

    const enableClick = (id, value) => {
        const newData = props.data.map((record) => enabledChangeMapping(id, value, record));
        props.changeHandler(props.config.Id, newData);   
    }

    const columnClick = (id, value) => {
        const newData = props.data.map((record) => columnChangeMapping(id, value, record));
        props.changeHandler(props.config.Id, newData);   
    }

    const enabledChangeMapping = (id, value, record) => {
        if (record.label === id)   {
            record.enabled = value;
        }
        return {label: record.label, value: record.value, enabled: record.enabled, combo: record.combo} 
    }

    const columnChangeMapping = (id, value, record) => {
        if (record.label === id)   {
            record.combo = value;
        }
        return {label: record.label, value: record.value, enabled: record.enabled, combo: record.combo} 
    }

    return (
        <div>
            <ArcSelector config={props.config} data={props.data} menuClick={menuClick} enableClick={enableClick} columnClick={columnClick} language={props.language}></ArcSelector>
        </div>
    )
}

export default ArcFieldSelector;